// order-sidenav-state.service.ts

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class OrderSidenavStateService {
  private readonly localStorageKey = 'sentOrderIds';

  private sentOrderIds: Set<string> = new Set<string>();

  constructor() {
    this.loadSentOrderIds();
  }

  private loadSentOrderIds(): void {
    const storedIds = localStorage.getItem(this.localStorageKey);
    this.sentOrderIds = new Set<string>(JSON.parse(storedIds) || []);
  }

  private saveSentOrderIds(): void {
    localStorage.setItem(
      this.localStorageKey,
      JSON.stringify(Array.from(this.sentOrderIds))
    );
  }

  addSentOrderId(orderId: string): void {
    this.sentOrderIds.add(orderId);
    this.saveSentOrderIds();
  }

  hasSentOrderId(orderId: string): boolean {
    this.scheduleClearing();
    return this.sentOrderIds.has(orderId);
  }

  clearSentOrderIds(): void {
    this.sentOrderIds.clear();
    localStorage.removeItem(this.localStorageKey);
  }
  scheduleClearing(): void {
    // Clear the sent order IDs after 4 hours
    setTimeout(() => {
      this.clearSentOrderIds();
    }, 4 * 60 * 60 * 1000);
  }
}
